import { render, staticRenderFns } from "./StatusWarning.vue?vue&type=template&id=75087c2c&"
import script from "./StatusWarning.vue?vue&type=script&lang=js&"
export * from "./StatusWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75087c2c')) {
      api.createRecord('75087c2c', component.options)
    } else {
      api.reload('75087c2c', component.options)
    }
    module.hot.accept("./StatusWarning.vue?vue&type=template&id=75087c2c&", function () {
      api.rerender('75087c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/StatusWarning.vue"
export default component.exports